import React from 'react'
import { actions } from 'features/Cart'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import BenefitsHeader from './BenefitsShowcase/BenefitsHeader'
import BenefitsWrapper from './BenefitsShowcase/BenefitsWrapper'
import BenefitsItem from './BenefitsShowcase/BenefitsItem'

import '@loyal_template/showcases.css'

const BenefitsShowcase = ({ onlyCash, BenefitsInfo }) => {
  return BenefitsInfo.map((item, index) => ((
    <div key={index} className={`bx-benefitsShowcase pos-relative py-3 ${onlyCash ? 'scope-onlyCash' : 'scope-points'}`}>
      <div className='container px-1 px-sm-0'>
        <BenefitsHeader {...item} />
        <BenefitsWrapper>
          {
            item.banners.map((banner, bannerIndex) => (
              <BenefitsItem key={bannerIndex} bannerIndex={bannerIndex} {...banner} />
            ))
          }
        </BenefitsWrapper>
      </div>
    </div>
  )
  ))
}

BenefitsShowcase.propTypes = {
  onlyCash: PropTypes.bool,
  BenefitsShowcase: PropTypes.object
}
BenefitsShowcase.defaultProps = {
  BenefitsInfo: [{
    'title': 'Veja uma seleção de benefícios especiais para você.',
    'titleMobile': 'Benefícios especiais para você.',
    'banners': [
      { 'name': 'Beneficios', 'className': 'col-12 col-lg-6 banner-home-beneficios', 'path': '/benefits/landing' },
      { 'name': 'Links',
        'className': 'mt-2 mt-md-0 col-12 col-lg-6 banner-home-links',
        'path': '#',
        'items': [
          {
            'name': 'Muitas opções',
            'description': 'Tudo o que você precisa das principais lojas em um único lugar',
            'icon': 'iconCompras',
            'className': 'pl-0',
            'path': '/search'
          },
          {
            'name': 'Ganhe + pontos​',
            'description': 'Compre no iupp e ganhe ainda mais pontos',
            'icon': 'iconCartoes',
            'className': 'pr-0',
            'path': '/search'
          },
          {
            'name': 'Use pontos',
            'description': 'Para comprar produtos, experiências e viagens',
            'icon': 'iconPontos',
            'className': 'mt-2 pl-0',
            'path': '/pointsandcash'
          },
          {
            'name': 'Comunidade iupp​',
            'description': 'Encontre ofertas perto de você',
            'icon': 'iconCumunidade',
            'className': 'mt-2 pr-0',
            'path': '/comunidade-iupp'
          }
        ] }

    ]
  }]
}
const mapStateToProps = ({ onlyCash }) => ({ onlyCash })

const mapDispatchToProps = dispatch => ({
  loadCart: () => dispatch(actions.loadCart())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BenefitsShowcase)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/BenefitsShowcase.js